import * as React from 'react'
import GoogleSigninButton from '../common/googleLogin/GoogleSigninButton'
import { googleLoginSignupHandler } from './ExternalLoginHandlers'
import { captureExceptionWithSentry } from '../sentry'

interface GoogleLoginButtonProps {
	clientId: string
	handleOnFail: (error: string) => void
	setUser: (token: string) => void
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ clientId, handleOnFail, setUser }) => {
	const googleLogin = async (response: any) => {
		try {
			const json = await googleLoginSignupHandler(response)
			setUser(json.data)
		} catch (error) {
			handleOnFail('Google sign-in failed. Please try again.')
			captureExceptionWithSentry(error)
		}
	}

	return <GoogleSigninButton clientId={clientId} googleLogin={googleLogin} text="signin_with" width="310" />
}

export default GoogleLoginButton
